//#region src/components/Priority/constants.ts
var PRIORITY_VALUE_NAME_MAP = {
	0: "None",
	1: "Low",
	2: "Medium",
	3: "High"
};
var PRIORITY_VALUE_VARIANT_MAP = {
	0: "neutral",
	1: "info",
	2: "caution",
	3: "critical"
};
//#endregion
export { PRIORITY_VALUE_NAME_MAP, PRIORITY_VALUE_VARIANT_MAP };

//# sourceMappingURL=constants.js.map